export function isInvoiceClosed(invoice: InvoiceData) {
  return invoice.is_closed;
}

export function isInvoiceWrittenOff(invoice: InvoiceData) {
  return (
    invoice.is_closed &&
    invoice.written_off_datetime &&
    invoice.amount_written_off > 0
  );
}

export function isInvoiceFullyPaid(invoice: InvoiceData) {
  return (
    invoice.is_closed &&
    invoice.amount_total_invoiced === invoice.amount_total_paid &&
    !invoice.refunded_datetime
  );
}

export function isInvoicePartiallyPaid(invoice: InvoiceData) {
  return (
    !invoice.is_closed &&
    invoice.amount_total_invoiced > invoice.amount_total_paid &&
    invoice.amount_total_paid !== 0
  );
}

export function isInvoiceRefunded(invoice: InvoiceData) {
  return invoice.refunded_datetime && invoice.amount_total_refunded > 0;
}

export function isInvoicePastDue(invoice: InvoiceData) {
  return new Date(invoice.invoice_due_by) < new Date() && !invoice.is_closed;
}

export function isInvoiceDeleted(invoice: InvoiceData) {
  return new Date(invoice.deleted_datetime);
}
